import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StorageService } from '../../../_shared/services';

@Component({
    selector: 'app-time-list',
    templateUrl: './time-list.component.html',
    styleUrls: ['./time-list.component.scss'],
})
export class TimeListComponent implements OnInit {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() public allData: any[];
    @Input() public title: string;
    @Input() public hiddeTimeButtons = false;
    @Input() public fullHeight = false;
    @Input() public hideCustomer = false;
    @Input() public icon: string;
    @Input() public height: number;
    @Input() public grayHeader = true;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    @Output() public onClickElement: EventEmitter<any>;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onTimeChange: EventEmitter<string>;
    public currentPage = 1;
    public selectedDay = true;
    public itemsPerPage = 5;
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public termData: any;
    constructor(public storage: StorageService) {
        this.onTimeChange = new EventEmitter();
        this.onClickElement = new EventEmitter();
    }

    ngOnInit() {
        this.termData = this.storage.getSelectedTerm();
    }

    public timeChange(time: string): void {
        if (time === 'week') {
            this.selectedDay = false;
        } else {
            this.selectedDay = true;
        }

        this.onTimeChange.emit(time);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public elementClicked(event: any): void {
        this.onClickElement.emit(event);
    }
}
